// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  width: 100%;
  margin-bottom: 6px;
}

.checkbox-price {
  color: #b5b5b5;
}

.hidden {
  visibility: hidden;
}

.price {
  margin-right: 10px;
  color: var(--ion-color-black);
  font-weight: 400;
}

.qty__btn {
  width: 24px;
  height: 24px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 19px;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--ion-color-primary);
}

ion-checkbox {
  margin: 0 12px 0 0;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #FFFFFF;
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #E2DCD5;
}

ion-label {
  font-size: 14px;
  font-family: AppFont, sans-serif;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-multiple/article-option-group-multiple.component.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,kBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,6BAAA;EACA,gBAAA;AAAF;;AAKE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;AAII;EACE,4BAAA;AAFN;AAKI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AAHN;AAOE;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,qBAAA;AANF;;AAQA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AALF;;AAOA;EACE,eAAA;EACA,gCAAA;AAJF;;AAOA;EACE,eAAA;AAJF","sourcesContent":["\nion-item {\n  width: 100%;\n  margin-bottom: 6px;\n}\n\n.checkbox-price {\n  color: #b5b5b5;\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.price {\n  margin-right: 10px;\n  color: var(--ion-color-black);\n  font-weight: 400;\n}\n\n.qty {\n\n  &__btn {\n    width: 24px;\n    height: 24px;\n    margin: 0 !important;\n    box-shadow: none;\n    --box-shadow: none;\n\n    button {\n      box-shadow: unset !important;\n    }\n\n    span {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      height: 19px;\n    }\n  }\n\n  .qty-number {\n    margin: 0 4px;\n    text-align: center;\n    min-width: 15px;\n    color: var(--ion-color-primary);\n  }\n}\n\nion-checkbox {\n  margin: 0 12px 0 0;\n}\n\napp-tag {\n  display: inline-block;\n}\nion-item{\n  background: #FFFFFF;\n  border-radius: 5px;\n  margin-top: 10px;\n  border: 0.5px solid #E2DCD5;\n}\nion-label {\n  font-size: 14px;\n  font-family: AppFont, sans-serif;\n}\n\n.pfand {\n  font-size: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
